import React from "react"
import { Card } from "react-bootstrap"
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js"
import { Bar } from "react-chartjs-2"
import { useAuth } from "../../context/AuthContext"

// Register ChartJS components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top"
    },
    title: {
      display: true,
      text: "Στατιστικά ανά Πραγματογνώμονα"
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const label = context.dataset.label || ""
          const value = context.parsed.y
          return `${label}: ${value} έλεγχοι`
        }
      }
    }
  },
  scales: {
    x: {
      stacked: true
    },
    y: {
      stacked: true,
      beginAtZero: true,
      ticks: {
        stepSize: 1,
        callback: function (value) {
          if (value % 1 === 0) {
            return value
          }
        }
      }
    }
  }
}

const ExpertStats = ({ data, loading, error }) => {
  const { appLookups } = useAuth()
  const statusLookups = appLookups?.filter(lookup => lookup.Table === "Status") || []

  if (loading) {
    return (
      <Card>
        <Card.Body className="d-flex justify-content-center align-items-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Φόρτωση...</span>
          </div>
        </Card.Body>
      </Card>
    )
  }

  if (error) {
    return (
      <Card>
        <Card.Body className="text-danger">
          <i className="fas fa-exclamation-circle me-2" />
          {error}
        </Card.Body>
      </Card>
    )
  }

  if (!data) return null

  const getStatusCount = (expertData, statusCode) => {
    const expertStats = data.filter(
      stat => stat.ExpertID === expertData.ExpertID && stat.StatusCode === statusCode
    )
    return expertStats.reduce((sum, stat) => sum + stat.Counter, 0)
  }

  // Group data by expert
  const experts = [...new Set(data.map(stat => stat.ExpertID))].map(expertId => ({
    ExpertID: expertId,
    ExpertName: expertId === 0 ? "Χωρίς Ανάθεση" : data.find(stat => stat.ExpertID === expertId)?.ExpertName
  }))

  const chartData = {
    labels: experts.map(expert => expert.ExpertName),
    datasets: statusLookups.map(status => ({
      label: status.Name,
      data: experts.map(expert => getStatusCount(expert, status.Code)),
      backgroundColor:
        status.Code === 0
          ? "rgba(108, 117, 125, 0.8)"
          : status.Code === 1
          ? "#ffb81e"
          : status.Code === 2
          ? "rgba(13, 110, 253, 0.8)"
          : status.Code === 10
          ? "rgba(25, 135, 84, 0.8)"
          : status.Code === 99
          ? "rgba(220, 53, 69, 0.8)"
          : "rgba(108, 117, 125, 0.8)",
      borderColor:
        status.Code === 0
          ? "rgba(108, 117, 125, 1)"
          : status.Code === 1
          ? "#ffb81e"
          : status.Code === 2
          ? "rgba(13, 110, 253, 1)"
          : status.Code === 10
          ? "rgba(25, 135, 84, 1)"
          : status.Code === 99
          ? "rgba(220, 53, 69, 1)"
          : "rgba(108, 117, 125, 1)",
      borderWidth: 1
    }))
  }

  return (
    <Card>
      <Card.Body>
        <div style={{ height: "400px" }}>
          <Bar data={chartData} options={options} />
        </div>
      </Card.Body>
    </Card>
  )
}

export default ExpertStats
